import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-popup',
  templateUrl: 'pop-up.component.html',
  styleUrls: ['./pop-up.component.scss'],
})
export class PopUpComponent implements OnInit, AfterViewInit {
  /* tslint:disable-next-line:no-input-rename */
  @Input('resposta') resposta;
  /* tslint:disable-next-line:no-input-rename */
  @Input('erro') error = false;
  /* tslint:disable-next-line:no-input-rename */
  @Input('mostrarPopUp') mostrarPopUp = true;
  /* tslint:disable-next-line:no-output-rename */
  @Output('submter') submter = new EventEmitter<any>();
  /* tslint:disable-next-line:no-output-rename */
  @Output('cancel') cancel = new EventEmitter<any>();
  /* tslint:disable-next-line:no-output-rename */
  @ViewChild('circle') circle: ElementRef;

  constructor() { }

  ngOnInit() { }

  ngAfterViewInit() {
    const circleLength = this.circle.nativeElement.getTotalLength();

    gsap.set(this.circle.nativeElement, {
      autoAlpha: 0,
      strokeDashoffset: circleLength,
      strokeDasharray: circleLength,
    });

    this.loading();
  }

  fechaPopUp() {
    this.cancel.emit();
  }

  tentarNovamente() {
    this.submter.emit();
  }

  cancelar() {
    this.cancel.emit();
  }

  loading() {
    const tl = gsap.timeline({ repeat: -1 }).to(this.circle.nativeElement, {
      duration: 2,
      autoAlpha: 1,
      strokeDashoffset: 0,
      ease: 'circ.inOut',
    });
  }
}
